// extracted by mini-css-extract-plugin
module.exports = {"block":"O6rc8","info":"LXgPb","title":"PeftI","subtitle":"eOhZT","form":"fGD4m"};